<template>
  <div>
    <h1 v-if="isChange">修改优惠套券</h1>
    <h1 v-else>优惠套券</h1>
    <el-form
      ref="suitForm"
      size="mini"
      :model="suitForm"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="套券名称" prop="packageName">
        <el-input
          style="width: 300px"
          v-model.trim="suitForm.packageName"
        ></el-input>
      </el-form-item>
      <el-form-item label="选择优惠券" prop="activityIds">
        <el-select
          style="width: 300px"
          v-model="suitForm.activityIds"
          placeholder="请选择选择优惠券"
          multiple
          @change="onChange"
        >
          <el-option
            v-for="item in selectedList"
            :key="item.id"
            :label="item.activityName"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="可售范围" prop="type">
        <el-radio-group v-model="suitForm.type">
          <el-radio :label="3">全部</el-radio>
          <el-radio :label="1">新用户</el-radio>
          <el-radio :label="2">老用户</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="金额" prop="preferentialPrice">
        <el-input
          style="width: 300px"
          v-model="suitForm.preferentialPrice"
        ></el-input>
      </el-form-item>
      <el-form-item label="划线价" prop="originalPrice">
        <el-input
          style="width: 300px"
          v-model="suitForm.originalPrice"
        ></el-input>
      </el-form-item>
      <el-form-item label="套券有效期" prop="validTime">
        <el-input style="width: 300px" v-model.number="suitForm.validTime">
          <template slot="append">天</template>
        </el-input>

        <span class="text">购买套券后，所选优惠券的有效期</span>
      </el-form-item>
      <el-form-item label="套券活动时间" required>
        <div class="typeTime">
          <el-form-item prop="startTime">
            <el-date-picker
              type="date"
              placeholder="开始时间"
              v-model="suitForm.startTime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 200px"
              @change="changeData(false)"
            ></el-date-picker>
          </el-form-item>
          <span class="text">至</span>
          <el-form-item prop="endTime">
            <el-date-picker
              type="date"
              placeholder="结束时间"
              v-model="suitForm.endTime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 200px"
              @change="changeData(false)"
            ></el-date-picker>
          </el-form-item>

          <span class="text"
            >指平台中可售卖的时间范围，过期后将不再显示，不设置则默认不限制</span
          >
        </div>
      </el-form-item>
      <el-form-item label="状态" prop="isOnline">
        <el-radio-group v-model="suitForm.isOnline">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">锁定</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button
          v-if="this.$route.query.id"
          type="primary"
          @click="handleUpdate"
          >保存</el-button
        >
        <el-button
          v-else
          type="primary"
          :loading="loading"
          @click="handleCreate()"
          >创建</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import api from "../api";
const { coupon } = api;
export default {
  name: "buyActivity",
  data() {
    var checkNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入套券有效期"));
      }
      if (value < 0) {
        return callback(new Error("请输入大于0的数字值"));
      }
      if (!Number.isInteger(value)) {
        callback(new Error("请输入数字值"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      suitForm: {
        packageName: "",
        activityIds: [],
        startTime: "",
        endTime: "",
        amount: "",
        type: 3,
        originalPrice: "",
        validTime: "",
        isOnline: 1,
      },
      selectedList: [],
      isChange: this.$route.query.id,
      rules: {
        packageName: [
          { required: true, message: "请输入套券名称", trigger: "blur" },
          { max: 15, message: "套券名称最多允许输入15个字符", trigger: "blur" },
        ],
        activityIds: [
          {
            required: true,
            message: "请选择选择优惠券",
            trigger: "change",
          },
        ],
        startTime: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "change",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择可售范围",
            trigger: "change",
          },
        ],
        preferentialPrice: [
          { required: true, message: "请输入金额", trigger: "blur" },
          { pattern: /^(\d+)((?:\.\d+)?)$/, message: "请输入合法金额数字" },
        ],
        originalPrice: [
          { required: false, message: "请输入金额", trigger: "blur" },
          { pattern: /^(\d+)((?:\.\d+)?)$/, message: "请输入合法金额数字" },
        ],
        validTime: [
          { required: true, message: "请输入套券有效期", trigger: "blur" },
          { required: true, validator: checkNumber, trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  created() {
    if (this.$route.query.id) {
      this.upList();
    } else {
      this.getSelected();
    }
  },
  methods: {
    upList() {
      coupon.Package({ id: this.$route.query.id }).then((res) => {
        if (res.data.code === 200) {
          this.suitForm = res.data.data;
          this.getSelected();
          console.log(res.data.data);
        }
      });
    },
    getSelected() {
      let obj = {
        forPeople: 6,
        activityType: 2,
        isOnline: 1,
      };
      coupon.activities(obj).then((res) => {
        if (res.data.code === 200) {
          this.selectedList = res.data.data;
        }
      });
    },
    onChange(value) {
      console.log(value, "value");
    },
    handleCreate() {
      this.loading = true;
      this.$refs.suitForm.validate((valid) => {
        if (valid) {
          coupon.couponCreate(this.suitForm).then((res) => {
            if (res.data.code === 200) {
              this.$message.success("创建成功！");
              this.loading = false;
              setTimeout(() => {
                this.goBuyList();
              }, 500);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleUpdate() {
      this.$set(this.suitForm, "id", this.$route.query.id);
      coupon.updatePackage(this.suitForm).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("修改成功！");
          setTimeout(() => {
            this.goBuyList();
          }, 500);
        }
      });
    },
    changeData(flag) {
      if (flag) {
        if (this.suitForm.startTime) {
          if (this.suitForm.startTime > this.suitForm.endTime) {
            this.suitForm.startTime = null;
            this.$message.error("开始时间不能大于结束时间！");
          }
        }
      } else {
        if (this.suitForm.startTime) {
          if (this.suitForm.endTime < this.suitForm.startTime) {
            this.suitForm.endTime = null;
            this.$message.error("结束时间不能小于开始时间！");
          }
        }
      }
    },
    goBuyList() {
      this.$router.push({
        path: "/coupon/packageList",
      });
    },
  },
};
</script>

<style  scoped>
.text {
  margin: 0 10px;
  color: #606266;
}
.typeTime {
  display: flex;
}
</style>>



// WEBPACK FOOTER //
// src/views/coupon/buyActivity.vue